import React, { useEffect, useState } from "react";
import BotFace, { raiderFaceSvg } from "@/components/BotFace";
import { onRaiderChange, raiderFor } from "@/lib/raiderLooks";

// A player's round picture: their raider's face, and their initial while
// that loads. Uploaded photos are gone (Jack, 2026-10-21: raiders only), so
// any old photo on the account is never shown. `version` is still accepted
// from callers but unused.
// Bots (`bot`, or the "bot" user id) show their raider's face instead.
export default function Avatar({ userId, username, bot = false, className = "", fallbackClassName = "bg-brand text-brand-foreground", children }) {
  const wantFace = !!userId && userId !== "bot" && !bot;
  const [face, setFace] = useState(null);
  const [rev, setRev] = useState(0); // bumps when this player saves a new raider
  useEffect(() => setFace(null), [userId]);
  useEffect(() => onRaiderChange((id) => { if (id === userId) setRev((r) => r + 1); }), [userId]);
  useEffect(() => {
    if (!wantFace) return undefined;
    let alive = true;
    raiderFor(userId).then((c) => { if (alive) setFace(raiderFaceSvg(c.look)); });
    return () => { alive = false; };
  }, [wantFace, userId, rev]);

  if (bot || userId === "bot") return <BotFace name={username} className={className} />;

  return (
    <span className={`relative inline-flex items-center justify-center rounded-full overflow-hidden flex-none font-bold ${fallbackClassName} ${className}`}>
      {children ?? (username?.[0]?.toUpperCase() || "?")}
      {wantFace && face && (
        <span className="absolute inset-0" style={{ background: "#fbe3e8" }} data-testid="raider-face" dangerouslySetInnerHTML={{ __html: face }} />
      )}
    </span>
  );
}
